import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 罗马尼亚
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} Toate drepturile rezervate',
    },
    auth: {
        login: 'Autentificare',
        username: 'Nume utilizator',
        username_placeholder: 'Introduceți numele de utilizator',
        password: 'Parolă',
        password_placeholder: 'Introduceți parola',
        code: 'Cod de verificare',
        code_placeholder: 'Introduceți codul de verificare',
        logout: 'Deconectare',
        logout_success: 'V-ați deconectat cu succes',
        day: 'zi',
        password_expiration: 'Valabilitatea parolei a expirat – vă rugăm să o schimbați',
        expire: 'Timp rămas până la expirarea parolei',
        conseils:
            'Trebuie să conțină litere mari, litere mici, cifre și caractere speciale ({msg}). Lungimea parolei trebuie să fie între 8 și 16 caractere.',
        brand_Selection: 'Selecție marcă',
        unread_notices: 'Notificări necitite',
        new_cases: 'Cazuri noi',
        unanswered_cases: 'Cazuri fără răspuns',
        overdue_cases: 'Cazuri restante',
    },
    button: {
        query: 'Interogare',
        editing_position: 'Editare post',
        show_theme_editor: 'Afișare/Ascundere editor temă',
        change_password: 'Schimbare parolă',
        old_password: 'Parolă veche',
        new_password: 'Parolă nouă',
        confirm_password: 'Confirmare parolă',
        button: 'Buton',
        about: 'Despre',
        back: 'Înapoi',
        go: 'OK',
        home: 'Acasă',
        confirm: 'Confirmă',
        modify: 'Modifică',
        edit: 'Editează',
        new: 'Nou',
        cancel: 'Anulează',
        close: 'Închide',
        search: 'Caută',
        reset: 'Resetează',
        delete: 'Șterge',
        add: 'Adaugă',
        collapse: 'Restrânge',
        expand: 'Extinde',
        download_template: 'Descarcă șablon',
        batch_import: 'Import în lot',
        import: 'Importă',
        export: 'Exportă',
        export_fail: 'Import eșuat',
        detailed: 'Detaliat',
        details: 'Detalii',
        download: 'Descarcă',
        toView: 'Vezi',
        toViews: 'Vezi imagini',
        uploadAttachments: 'Încarcă atașamente',
        selectFile: 'Selectează fișier',
        fillingInstructions: 'Instrucțiuni de completare',
        release: 'Publică',
        release_recall: 'Retrage publicarea',
        save: 'Salvează',
        send: 'Trimite',
        tips: 'Sfaturi',
        send_back: 'Returnează',
        examine: 'Examinează',
        void: 'Anulează',
        more: 'Mai mult',
        refresh: 'Reîmprospătează',
        selects: 'Selectează',
        serial_number: 'Număr de serie',
        upload_progress: 'Progres încărcare',
        invalid: 'Invalid',
        daily_record: 'Jurnal zilnic',
        operation_type: 'Tip operațiune',
        field_name: 'Nume câmp',
        edit_role: 'Editare rol',
        user_role: 'Selectează rol',
        assignment_role: 'Rol',
        post: 'Post',
        sending: 'Se trimite...',
        reset_password: 'Resetează parola',
        display_or_not: 'Afișează sau nu',
        document: 'Document',
        specificTemplates: 'Șabloane specifice',
        transferOrder: 'Transferă comandă',
        forwarding: 'Redirecționează',
        one_click_notification: 'Notificare cu un singur clic',
        english_export: 'Export în engleză',
        oneclick_download: 'Descărcare cu un singur clic',
        passwordmsga:
            'Trebuie să conțină litere mari, litere mici, cifre și caractere speciale (@\\$!_~\\&*)',
        passwordmsgb: 'Lungimea parolei trebuie să fie între 8 și 16 caractere',
        passwordmsgc: 'Nu poate fi identică cu niciuna dintre ultimele șase parole',
        export_file_list: 'Listă fișiere exportate',
        personal_center: 'Centru personal',
        upload_list: 'Listă încărcări',
        clear_completed: 'Șterge finalizate',
    },
    radio: {
        enabled: 'Activat',
        disabled: 'Dezactivat',
        catalogue: 'Catalog',
        individual: 'Individual',
        all: 'Toate',
        yes: 'Da',
        no: 'Nu',
    },
    dropdown: {
        close_others: 'Închide altele',
        close_right: 'Închide cele din dreapta',
        close_left: 'Închide cele din stânga',
    },
    table: {
        action: 'Acțiune',
        explain: 'Explicație',
        fileName: 'Nume fișier',
        size: 'Dimensiune (MB)',
        uploader: 'Încărcat de',
        uploadTime: 'Data încărcării',
        system: 'Sistem',
        caption: 'Titlu',
        categorization: 'Categorizare',
        link: 'Link',
        forwarding_time: 'Data redirecționării',
        forwarder: 'Redirecționat de',
        send_to: 'Trimite către',
        mode: 'Mod',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `Pagina ${named('number')}`,
        total: ({ named }: Parameters<MessageFunction>[0]) =>
            `Total ${named('number')} înregistrări`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) =>
            `Total ${named('number')} vehicule`,
    },
    confirm: {
        confirm_deletion: 'Confirmați ștergerea?',
        confirm_void: 'Confirmați anularea?',
        confirm_release: 'Confirmați publicarea?',
        ack: 'Confirmă',
        cancel: 'Anulează',
        non_records: 'Selectați cel puțin o înregistrare',
    },
    request: {
        failed_placeholder: 'Solicitare eșuată – eroare server',
        success_placeholder: 'Solicitare reușită',
        auth: {
            login_success: 'Autentificare reușită',
        },
        error: {
            '404': 'Resursa nu a fost găsită',
            '403': 'Permisiuni insuficiente',
        },
    },
    page: {
        global: {
            page_search: 'Căutare pe pagină',
        },
        error: {
            not_found: 'Pagina nu a fost găsită',
            not_found_des: 'Nimic aici',
            auth_failed: 'Permisiuni insuficiente',
            auth_failed_des: 'Această pagină este interzisă',
            file_format_error: 'Format fișier invalid!',
            preview_failed: 'Previzualizare eșuată! Fișierul este corupt!',
        },
        homepage: {
            homepage: homepage.homepage.roRO,
        },
        system: {
            menu: system.menu.roRO,
            dict: system.dict.roRO,
            dept: system.dept.roRO,
            role: system.role.roRO,
            user: system.user.roRO,
        },
        info: {
            announcement: Info.announcement.announcement.roRO,
            document: Info.document.document.roRO,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.roRO,
                recallActivity: tech.quality.recallActivity.roRO,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.roRO,
            },
            management: {
                inquiryOd: tech.management.inquiry.roRO,
                permission: tech.management.permission.roRO,
                onSiteSupportHq: tech.management.onSiteSupport.roRO,
                progHistoryHq: tech.management.progHistory.roRO,
                salesRecordHq: tech.management.salesRecord.roRO,
                vehicleInfoHq: tech.management.vehicleInfo.roRO,
                claimHq: tech.management.claim.roRO,
                filterHq: tech.management.filter.roRO,
                newCarlssue: tech.management.newCarIssue.roRO,
                newCarDefinition: tech.management.newCarDefinition.roRO,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.roRO,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.roRO,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.roRO,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.roRO,
        },
        statistics: statistics.inquiryStatistics.roRO,
        systemClassifyA: statistics.systemClassifyA.roRO,
        systemClassifyB: statistics.systemClassifyB.roRO,
        engineerStatistics: statistics.engineerStatistics.roRO,
        defectivePart: statistics.defectivePart.roRO,
        replyInquiryStatistics: statistics.replyInquiryStatistics.roRO,
        passRateStatistics: statistics.passRateStatistics.roRO,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.roRO,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.roRO,
        customsClearance135Rate: statistics.customsClearance135Rate.roRO,
        accumulatedClosureRate: statistics.accumulatedClosureRate.roRO,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.roRO,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.roRO,
    },
    validation: {
        common: {
            required: 'Acest câmp este obligatoriu',
            numeric: 'Trebuie să fie un număr întreg',
            decimal: 'Trebuie să fie un număr',
            positive_interger: 'Trebuie să fie un număr întreg pozitiv',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `Maximum ${named('number')} cifre`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Nu mai mult de ${named('number')} caractere permise`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `Numărul maxim de caractere a fost depășit (${named('number')})`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Trebuie să aibă cel puțin ${named('number')} caractere`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Trebuie să aibă exact ${named('number')} caractere`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Nu poate fi mai mare decât ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Nu poate fi mai mic decât ${named('number')}`,
            up_to_2_decimal_places: 'Maximum două zecimale',
            retain_up: 'Maximum 10 cifre înainte de virgulă și 2 după',
            retain_ups: 'Maximum 11 cifre înainte de virgulă și 4 după',
            input_number: 'Introduceți doar cifre arabe',
            only_number_a: 'Doar litere sau cifre sunt permise',
            translate: 'Doar litere sunt permise',
            positive_integer: 'Completați cel puțin un câmp',
            at_least_one: 'Completați cel puțin unul',
        },
        tip: {
            incomplete_information: 'Informațiile sunt incomplete',
        },
    },
    import: {
        template_file: 'Fișier șablon',
        browse: 'Răsfoiește',
        download_template: 'Descarcă șablon',
        no_file_selected: 'Niciun fișier selectat',
        incorrect_file_type: 'Tip fișier incorect',
        exceed: 'Limită depășită',
        upload_success: 'Încărcare reușită',
        upload_fail: 'Încărcare eșuată',
        again_upload:
            'Doar imaginile în formatele jpg, png, bmp sau gif pot fi încărcate. Încercați din nou.',
        attachmentUpload: 'Încărcare atașamente',
        otherAttachmentUpload: 'Încărcare alte atașamente',
        supportedFormats: 'Formate acceptate',
        preview: 'Previzualizare',
    },
    export: {
        noDataToExport: 'Nu există date de exportat',
    },
    select: {
        all: 'Toate',
    },
    checkbox: {
        select_all: 'Selectează tot',
    },
    dialog: {
        error_message: 'Mesaj de eroare',
        one_year: 'Puteți exporta maxim un an de date odată',
    },
    ymd: {
        year: 'an',
        month: 'lună',
        day: 'zi',
        week: 'săptămână',
        january: 'Ianuarie',
        february: 'Februarie',
        march: 'Martie',
        april: 'Aprilie',
        may: 'Mai',
        june: 'Iunie',
        july: 'Iulie',
        august: 'August',
        september: 'Septembrie',
        october: 'Octombrie',
        november: 'Noiembrie',
        december: 'Decembrie',
    },
};
